import EditConsumerScreen from "../modules/users/EditConsumerScreen"

export default function EditConsumer() {
  return (
    <>
      <EditConsumerScreen />
    </>
  )
}
